import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { useCustomerType } from "@faire/help-center-utils/hooks/useCustomerType";
import { Row } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

import { BrandTopics } from "./BrandTopics";
import { RetailerTopics } from "./RetailerTopics";

export const CommonTopics: React.FC = () => {
  const { customerType } = useCustomerType();
  return (
    <CommonTopicsWrapper>
      {customerType === CustomerTypes.RETAILER ? (
        <RetailerTopics />
      ) : (
        <BrandTopics />
      )}
    </CommonTopicsWrapper>
  );
};

const CommonTopicsWrapper = styled(Row).attrs({
  justify: { mobileAndAbove: "flex-start", desktopAndAbove: "center" },
  align: "center",
})`
  ${responsiveMediaQueries.mobile} {
    text-align: left;
  }
  ${responsiveMediaQueries.tabletAndAbove} {
    text-align: center;
  }
`;

export const EndWithComma = styled.span`
  text-wrap: nowrap;
  &::after {
    content: ",";
  }

  &:last-child::after {
    content: "";
  }
`;
